<template>

  <div id="coursePage" ref="main">

    <topnav :default_placeholder = "this.placeholder"></topnav>

    <main>

      <!--<breadCrumb-->
        <!--:previous_links=this.previous_links-->
        <!--:current_link=this.current_link-->
      <!--&gt;</breadCrumb>-->

      <!--<p>route: {{this.$route.params.user}}</p>-->

      <div id="courseContent" class="whiteBG">

        <div id="courseIntro">
          <div class="trailer">
            <div v-if="course.trailer_url" v-show="!displayImage">
              <div class="iframeContainer" v-if="this.course.trailer_url.includes('www.youtube.com')">
                <iframe v-if="this.iframe" ref="trailer" width="100%" height="100%" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen :src="this.course.trailer_url"></iframe>
              </div>
              <div class="iframeContainer" v-else-if="this.course.trailer_url.includes('vimeo.com')">
                <iframe v-if="this.iframe" ref="trailer" width="100%" height="auto" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen :src="this.course.trailer_url"></iframe>
              </div>
              <video ref="trailer" v-else  :poster="this.course.image_url" controls><source :src="this.course.trailer_url"></video>
            </div>
            <div v-if="displayImage">
              <img :src="this.course.image_url">

            </div>
            <div id="playbutton" v-if="course.trailer_url&&displayImage" @click="play"><i class="fas fa-play"></i></div>
          </div>
          <!--<img :src="this.course.image">-->
          <div id="courseIntroText">

            <h1>{{this.course.name}}</h1>
            <div class="table">
                <!--<div class="td" v-if="this.course.next_start_date">-->
                  <!--<div class="label"><img src="../../assets/img/atom/icon/light/next_start_date.svg"><span class="note">Next Start Date</span></div>-->
                  <!--<p class="value">{{this.course.next_start_date}}</p>-->
                <!--</div>-->
                <div class="td" v-if="this.course.provider">
                  <div class="label"><img src="../../assets/img/atom/icon/light/provider.svg"><span class="note">Provider</span></div>
                  <router-link :to="{name:'provider', params:{provider_id:this.course.provider.id}}" target="_blank" class="value brick">{{this.course.provider.name}}</router-link>
                </div>
                <div class="td" v-if="this.course.platform">
                  <div class="label"><img src="../../assets/img/atom/icon/light/platform.svg"><span class="note">Platform</span></div>
                  <p class="value"><a :href="this.course.platform.link" class="brick" target="_blank">{{this.course.platform.name}}</a></p>
                </div>
                <div class="td" v-if="this.course.language">
                  <div class="label"><img src="../../assets/img/atom/icon/light/language.svg"><span class="note">Language</span></div>
                  <p class="value">{{this.course.language}}</p>
                </div>
                <div class="td" v-if="this.course.subtitle">
                  <div class="label"><img src="../../assets/img/atom/icon/light/subtitle.svg"><span class="note">Subtitle</span></div>
                  <p class="value">{{this.course.subtitle}}</p>
                </div>
                <div class="td" v-if="this.course.certificate">
                  <div class="label"><img src="../../assets/img/atom/icon/light/certificate.svg"><span class="note">Certificate</span></div>
                  <p class="value">{{this.course.certificate}}</p>
                </div>
                 <!--<div class="td" v-if="this.course.duration">-->
                  <!--<div class="label"><img src="../../assets/img/atom/icon/light/duration.svg"><span class="note">Duration</span></div>-->
                  <!--<p class="value">{{this.course.duration}}</p>-->
                <!--</div>-->
                <div class="td" v-if="this.course.effort">
                  <div class="label"><img src="../../assets/img/atom/icon/light/effort.svg"><span class="note">Effort</span></div>
                  <p class="value">{{this.course.effort}}</p>
                </div>
                <div class="td" v-if="this.course.level">
                  <div class="label"><img src="../../assets/img/atom/icon/light/level.svg"><span class="note">Level</span></div>
                  <p class="value">{{this.course.level}}</p>
                </div>
            </div>
            <div id="courseActions">
              <router-link :to="{name:'syllabus'}" id="viewSyllabus" v-if="course.syllabus">
                <svg  class="linkChild" width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>syllabus</title>
                  <g id="0.-Library" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="molecule/view-syllabus" fill="#B19967" fill-rule="nonzero">
                          <g id="Molecule/View-Syllabus">
                              <path d="M4.24998987,2.87502414 C4.14582361,2.87502414 4.05728183,2.83856573 3.9843655,2.7656494 C3.91144917,2.69273307 3.87499076,2.60419129 3.87499076,2.50002503 L3.87499076,1.50002742 C3.87499076,1.39586116 3.91144917,1.30731939 3.9843655,1.23440305 C4.05728183,1.16148672 4.14582361,1.12502831 4.24998987,1.12502831 L15.499963,1.12502831 C15.6041293,1.12502831 15.6926711,1.16148672 15.7655874,1.23440305 C15.8385037,1.30731939 15.8749622,1.39586116 15.8749622,1.50002742 L15.8749622,2.50002503 C15.8749622,2.60419129 15.8385037,2.69273307 15.7655874,2.7656494 C15.6926711,2.83856573 15.6041293,2.87502414 15.499963,2.87502414 L4.24998987,2.87502414 Z M15.8749622,7.50001311 C15.8749622,7.60417937 15.8385037,7.69272115 15.7655874,7.76563748 C15.6926711,7.83855381 15.6041293,7.87501222 15.499963,7.87501222 L4.24998987,7.87501222 C4.14582361,7.87501222 4.05728183,7.83855381 3.9843655,7.76563748 C3.91144917,7.69272115 3.87499076,7.60417937 3.87499076,7.50001311 L3.87499076,6.5000155 C3.87499076,6.39584924 3.91144917,6.30730746 3.9843655,6.23439113 C4.05728183,6.1614748 4.14582361,6.12501639 4.24998987,6.12501639 L15.499963,6.12501639 C15.6041293,6.12501639 15.6926711,6.1614748 15.7655874,6.23439113 C15.8385037,6.30730746 15.8749622,6.39584924 15.8749622,6.5000155 L15.8749622,7.50001311 Z M15.8749622,12.5000012 C15.8749622,12.6041675 15.8385037,12.6927092 15.7655874,12.7656256 C15.6926711,12.8385419 15.6041293,12.8750003 15.499963,12.8750003 L4.24998987,12.8750003 C4.14582361,12.8750003 4.05728183,12.8385419 3.9843655,12.7656256 C3.91144917,12.6927092 3.87499076,12.6041675 3.87499076,12.5000012 L3.87499076,11.5000036 C3.87499076,11.3958373 3.91144917,11.3072955 3.9843655,11.2343792 C4.05728183,11.1614629 4.14582361,11.1250045 4.24998987,11.1250045 L15.499963,11.1250045 C15.6041293,11.1250045 15.6926711,11.1614629 15.7655874,11.2343792 C15.8385037,11.3072955 15.8749622,11.3958373 15.8749622,11.5000036 L15.8749622,12.5000012 Z M2.74999344,3.00002384 C2.74999344,3.1041901 2.71353504,3.19273187 2.6406187,3.26564821 C2.56770237,3.33856454 2.4791606,3.37502295 2.37499434,3.37502295 L0.374999106,3.37502295 C0.270832847,3.37502295 0.182291073,3.33856454 0.109374739,3.26564821 C0.0364584054,3.19273187 0,3.1041901 0,3.00002384 L0,1.00002861 C0,0.895862351 0.0364584054,0.807320577 0.109374739,0.734404244 C0.182291073,0.66148791 0.270832847,0.625029504 0.374999106,0.625029504 L2.37499434,0.625029504 C2.4791606,0.625029504 2.56770237,0.66148791 2.6406187,0.734404244 C2.71353504,0.807320577 2.74999344,0.895862351 2.74999344,1.00002861 L2.74999344,3.00002384 Z M2.74999344,8.00001192 C2.74999344,8.10417818 2.71353504,8.19271995 2.6406187,8.26563629 C2.56770237,8.33855262 2.4791606,8.37501103 2.37499434,8.37501103 L0.374999106,8.37501103 C0.270832847,8.37501103 0.182291073,8.33855262 0.109374739,8.26563629 C0.0364584054,8.19271995 0,8.10417818 0,8.00001192 L0,6.00001669 C0,5.89585043 0.0364584054,5.80730866 0.109374739,5.73439232 C0.182291073,5.66147599 0.270832847,5.62501758 0.374999106,5.62501758 L2.37499434,5.62501758 C2.4791606,5.62501758 2.56770237,5.66147599 2.6406187,5.73439232 C2.71353504,5.80730866 2.74999344,5.89585043 2.74999344,6.00001669 L2.74999344,8.00001192 Z M2.74999344,13 C2.74999344,13.1041663 2.71353504,13.192708 2.6406187,13.2656244 C2.56770237,13.3385407 2.4791606,13.3749991 2.37499434,13.3749991 L0.374999106,13.3749991 C0.270832847,13.3749991 0.182291073,13.3385407 0.109374739,13.2656244 C0.0364584054,13.192708 0,13.1041663 0,13 L0,11.0000048 C0,10.8958385 0.0364584054,10.8072967 0.109374739,10.7343804 C0.182291073,10.6614641 0.270832847,10.6250057 0.374999106,10.6250057 L2.37499434,10.6250057 C2.4791606,10.6250057 2.56770237,10.6614641 2.6406187,10.7343804 C2.71353504,10.8072967 2.74999344,10.8958385 2.74999344,11.0000048 L2.74999344,13 Z" id="syllabus"></path>
                          </g>
                      </g>
                  </g>
              </svg>
                VIEW SYLLABUS
              </router-link>
              <a :href="this.course.url" target="_blank" id="gotoCourse" class="nobrick" @click="captureOutboundLink(course.url)"><button class="btnPrimary">Go to Course<i class="fas fa-arrow-right"></i></button></a>
            </div>
          </div>
        </div>

        <div class="intro">
          <div v-if="this.course.description">
            <div id="relatedConcepts" class="frame" v-if="course.concepts">
              <p class="sectionTitle">Concepts in this course</p>
              <div>
                <router-link :to="{name:'map',params:{id:concept.concept_id}}" v-for="concept in this.course.concepts" class="concept">{{concept.name}}</router-link>
              </div>
            </div>
            <div id="aboutCourse" class="frame">
              <p class="sectionTitle">About this course</p>
              <readMore v-if="this.course.description.length<this.slice"
                :text_display="course.description"
                :text_full="course.description"
                :slice=slice
              ></readMore>
              <readMore v-else
                :text_display="course.description.slice(0,300)+'...'"
                :view="intro_view_more"
                :view_more="intro_view_more"
                :view_less="intro_view_less"
                :text_less="course.description.slice(0,300)+'...'"
                :text_full="course.description"
                :slice="slice"
              ></readMore>
            </div>
          </div>


            <div id="instructor" v-if="course.instructor_list.length>0">
              <p class="sectionTitle">Instructor
                <span class="viewall" v-if="course.instructor_list.length>2 & !view_all_instructor" @click="toggleAllInstructors">view all {{course.instructor_list.length}} instructors <i class="fas fa-plus"></i></span>
                <span class="viewall" v-if="course.instructor_list.length>2 & view_all_instructor" @click="toggleAllInstructors">collapse <i class="fas fa-minus"></i></span>
              </p>
              <InstructorProfile
                v-for="instructor in course.instructor_list.slice(0,show_instructor_number)"
                :id = "instructor.id"
                :key="instructor.id"
                :avatar="instructor.image_url"
                :title="instructor.title"
                :provider="instructor.provider"
                :name="instructor.name"
                :course_number="instructor.courses.length"
              ></InstructorProfile>
            </div>

        </div>
        <carousel
          :type = "'course'"
          :title = "'Related Courses'"
          :cardList = "this.course.related_courses"
        >
        </carousel>
      </div>
    </main>
    <backto-top></backto-top>
    <Footer></Footer>
  </div>

</template>

<script>
import Topnav from '../General/Topnav'
import ReadMore from '../General/ReadMore'
import BacktoTop from '../General/BacktoTop'
import InstructorProfile from '../General/InstructorProfile'
import CourseCardSquare from '../General/CourseCardSquare'
import Footer from '../General/Footer'
import {getCourses, gotoCourse} from "../../api/api";
import Carousel from '../General/Carousel'

export default {
  name: 'CoursePage',
  components: {
    ReadMore,
    CourseCardSquare,
    BacktoTop,
    Topnav,
    InstructorProfile,
    Footer,
    Carousel
  },
  metaInfo(){
      return{
          title: this.course.name,
          meta: [
              { name: 'description', content: this.course.description },
              { property: 'og:title', content: this.course.name },
              { property: 'og:description', content: this.course.description },
              { property: 'og:image', content: this.course.image_url },
              { name: 'twitter:title', content: this.course.name },
          ]
      }
  },
  data () {
    return {
      iframe: false,
      previous_links: [{title: '', url: ''}],
      displayImage: true,
      current_link: '',
      placeholder: 'duck',
      intro_view_more: '(+ read more)',
      intro_view_less: '(- read less)',
      slice: 300,
      view_all_instructor:false,
      show_instructor_number:2,
      course: {},
      concepts:[]
    }
  },
  methods: {
    play:function(){
      this.displayImage=!this.displayImage;
      this.iframe = true;
      this.$refs.trailer.play();
    },
    toggleAllInstructors:function(){
          this.view_all_instructor = !this.view_all_instructor;
          if(this.view_all_instructor){
              this.show_instructor_number=this.course.instructor_list.length
          }
          else{
              this.show_instructor_number=2
          }
      },
    getCourseInfo() {
      if (this.$route.params.id) {
        getCourses({
          id: this.$route.params.id
        }).then((response) => {
          this.course = response.data
          this.current_link = this.course.name
          this.previous_links.title = this.course.domain.name
          })
        }
    },


    captureOutboundLink: function(url) {
        //for our own analysis
        gotoCourse({course_url: url, origin: 'course'});
    },
  },
  created() {
    this.getCourseInfo();
  }
}
</script>

<style>
  @import '../../assets/style/general.css';
  @import '../../assets/style/page.css';

  /*tablet and laptop*/
  @media only screen
  and (max-device-width: 1199px) {
    #coursePage main{
      width:90%;
    }
    #courseContent{
      padding: 30px 60px;
    }
  }

  /*phone*/
  @media only screen
  and (max-device-width: 600px) {
    #courseContent{
      padding: 30px 20px;
    }
    #courseContent #courseIntro{
      flex-wrap: wrap;
    }
    #courseContent #courseIntro .trailer{
      margin: 0 0 20px 0;
    }
    #courseContent #courseIntroText{
      width:100%;
      display: block;
     }
    #courseContent #courseIntroText .table{
      grid-template-columns: 100% !important;
    }
    #courseContent .intro{
      grid-template-columns: 100% !important;
    }
    #courseContent .intro #instructor{
      margin:20px 0 0 0;
    }
    #courseContent .displayArea{
      width:250px;
      padding:20px 5px;
      margin:0 auto;
    }
    .carousel #previous{
      left:-20px !important;
    }
    .carousel #next{
      right:-20px !important;
    }
    #courseContent #viewSyllabus{
      display: none !important;
    }
    #courseContent #gotoCourse{
      margin-top: 20px;
      width:100%;
    }
    #courseContent #gotoCourse button{
      display: block;
      width:100%;
      padding:12px 20px;
      color:#fff;
      background-color: #FA6400;
    }
    #courseContent #gotoCourse button i{
      color:#fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Course/CoursePage.vue